// src/services/api/expenses.js
import { apiClient } from './base';

export const getExpenses = async (params = {}) => {
  try {
    const response = await apiClient.get('/expenses', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getExpenseById = async (id) => {
  try {
    const response = await apiClient.get(`/expenses/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createExpense = async (data) => {
  try {
    const response = await apiClient.post('/expenses', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateExpense = async (id, data) => {
  try {
    const response = await apiClient.put(`/expenses/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteExpense = async (id) => {
  try {
    const response = await apiClient.delete(`/expenses/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getExpenseCategories = async () => {
  try {
    const response = await apiClient.get('/expenses/categories');
    return response.data;
  } catch (error) {
    throw error;
  }
};
